/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * dataprocessStep
 */
export interface DataprocessStep { 
    id?: number;
    /**
     * id of dataprocessProcess
     */
    dataprocessProcessId?: number;
    /**
     * name of the dataprocessStep
     */
    name?: string;
    /**
     * description of the dataprocessStep
     */
    description?: string;
    /**
     * jsonString for the icon of the dataprocessSteps
     */
    icon?: string;
    /**
     * the dataprocessSteps are sorted according to this value
     */
    sort?: number;
    /**
     * id of dataprocessSteptype
     */
    dataprocessSteptypeId?: number;
    /**
     * jsonString for the stepDependencies of the dataprocessStep
     */
    stepDependencies?: string;
    /**
     * jsonString for the stepCommand of the dataprocessStep
     */
    stepCommand?: string;
    /**
     * jsonString for the stepVariables of the dataprocessStep
     */
    stepVariables?: string;
}

